import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./ScheduleModal.module.css";
import { Close } from "@mui/icons-material";
import { formatToDecimals } from "../../../helpers/dateFormat";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";

const ScheduleUpdateModal = ({
  type,
  open,
  handleClose,
  blocks,
  handleUpdateSubmit,
  data,
}) => {
  const [viewUpdate, setViewUpdate] = useState(blocks);
  let scheduleVolMw = data?.scheduleVolume / (data?.totalBlock / 4);

  useEffect(() => {
    if (type === "deliver") {
      const updatedData = blocks?.map((block) => ({
        ...block,
        deliveredVolume: block?.scheduleVolume?.toFixed(2),
        delierEditVolume: block?.scheduleVolume?.toFixed(2),
      }));
      setViewUpdate(updatedData);
    } else if (type === "edit") {
      const updatedData = blocks?.map((block) => ({
        ...block,
        scheduleEditVolume: block?.scheduleVolume?.toFixed(2),
      }));
      setViewUpdate(updatedData);
    }
  }, [blocks, type]);

  const handleUpdateScheduleVol = (val, index) => {
    if (type === "edit") {
      setViewUpdate((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          scheduleEditVolume: val,
        };
        return updated;
      });
    } else {
      setViewUpdate((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          delierEditVolume: val,
        };
        return updated;
      });
    }
  };

  const handleUpdate = () => {
    let updatedBlocks = viewUpdate?.map((block) => {
      const { scheduleEditVolume, delierEditVolume, ...rest } = block;
      return {
        ...rest,
        scheduleVolume: Number(
          type === "edit" ? block?.scheduleEditVolume : block?.scheduleVolume,
        ),
        deliveredVolume: Number(
          type === "deliver" ? block?.delierEditVolume : block?.deliveredVolume,
        ),
      };
    });
    handleUpdateSubmit(updatedBlocks);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.scheduleEditModal}`}>
        <div className={`display_flex_row modalHeading ${Styles.modalHeading}`}>
          <div className="headingText">
            {type === "edit" ? "Edit Schedule" : "Confirm Schedule"}
          </div>
          <Close
            style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.scheduleEditMainCont}>
          <div className={`display_flex_row tableHeading_type2`}>
            <div style={{ width: "10%" }}>Start Time</div>
            <div style={{ width: "10%" }}>End Time</div>
            <div style={{ width: "15%" }}>Scheduled Volume (MW)</div>
            <div style={{ width: "30%" }}>Scheduled Volume (MWh)</div>
            <div style={{ width: "30%" }}>Delivered Volume (MWh)</div>
          </div>
          <div className={`scroll_bar_y ${Styles.scrollMainSection}`}>
            {viewUpdate?.map((ele, index) => (
              <div
                className={`display_flex_row tableDetails ${Styles.tab_det_cont}`}
              >
                <div style={{ width: "10%" }}>
                  {ele?.timeBlock?.split("-")?.[0]}
                </div>
                <div style={{ width: "10%" }}>
                  {ele?.timeBlock?.split("-")?.[1]}
                </div>
                <div style={{ width: "15%" }}>{scheduleVolMw?.toFixed(2)}</div>
                <div
                  style={{ width: "30%" }}
                  className="display_flex_row_gap_8"
                >
                  <div className={type === "edit" && Styles.text_input_head}>
                    {formatToDecimals(ele?.scheduleVolume)}
                  </div>
                  {type === "edit" && (
                    <div className={Styles.edit_input_schedule}>
                      <input
                        type="text"
                        value={ele?.scheduleEditVolume}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val > Number(ele?.scheduleVolume)) {
                            handleUpdateScheduleVol(
                              ele?.scheduleVolume?.toFixed(2),
                              index,
                            );
                            return ErrorMessage(
                              `Updated value should be less then ${formatToDecimals(
                                ele?.scheduleVolume,
                              )}`,
                            );
                          }
                          // Allow only numbers with up to 2 decimal places
                          if (/^\d*\.?\d{0,2}$/.test(val)) {
                            handleUpdateScheduleVol(val, index);
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={{ width: "30%" }}>
                  {type === "edit" ? (
                    "-"
                  ) : (
                    <div className="display_flex_row_gap_8">
                      <div className={Styles.text_input_head}>
                        {formatToDecimals(ele?.deliveredVolume)}
                      </div>
                      <div className={Styles.edit_input_schedule}>
                        <input
                          type="text"
                          value={ele?.delierEditVolume}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val > Number(ele?.scheduleVolume)) {
                              handleUpdateScheduleVol(
                                ele?.scheduleVolume?.toFixed(2),
                                index,
                              );
                              return ErrorMessage(
                                `Updated value should be less then ${formatToDecimals(
                                  ele?.scheduleVolume,
                                )}`,
                              );
                            }
                            // Allow only numbers with up to 2 decimal places
                            if (/^\d*\.?\d{0,2}$/.test(val)) {
                              handleUpdateScheduleVol(val, index);
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={`display_flex_row_center ${Styles.buttonMainCont}`}>
          <div
            style={{ width: "200px", height: "40px" }}
            onClick={handleUpdate}
            className={`primary-button ${Styles.buttonList}`}
          >
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ScheduleUpdateModal;
